<template>
  <div class="experience-wrapper--reviews-navbar">
    <el-container>
      <div class="experience-wrapper--reviews-navbar-content">
        <LazyHydrate never>
          <!-- <div class="reviews-navbar-payments">
            <img
              :src="svgIconName"
              width="100%"
              height="20px"
              :alt="getAltAvailableMethods"
            />
          </div> -->
        </LazyHydrate>
      </div>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CacheComponentMixin from '@/utils/mixin/cache-components'

export default {
  name: 'LadExperienceReviewNavbar',
  mixins: [CacheComponentMixin],
  data() {
    return {
      base: 'experience.provider',
      baseReview: 'experience.navbar.review',
    }
  },
  computed: {
    ...mapState('experience', {
      exReviews: 'reviews',
    }),
    ...mapGetters('device', ['isMobile']),
    ...mapState('settings', ['currency']),
    facebookUrl() {
      return process.env.FACEBOOK_URL
    },
    rating() {
      return this.exReviews.value
    },
    svgIconName() {
      return require(`@/assets/sprite/svg/payments/localadventures-payments-${this.currency.toLowerCase()}.svg`)
    },
    availableMethods() {
      let items = ['card']

      switch (this.currency) {
        case 'MXN':
          items = [].concat(items, ['spei', 'oxxo', 'mercadopago'])
          break
        case 'COP':
          // items = [].concat(items, ['eft', 'efecty', 'nequi'])
          break
        case 'USD':
        default:
          break
      }

      return items
    },
    getAltAvailableMethods() {
      return `${this.$t(
        `checkout.common.payment_methods`
      )} (${this.availableMethods
        .map((method) => this.$t(`general.payment_method.${method}`))
        .join(',')})`
    },
  },
}
</script>

<style lang="scss" scope>
.experience-wrapper--reviews-navbar {
  // background-color: white;
  min-height: 60px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    background-color: unset;
    margin-bottom: 0;
  }

  .el-container {
    padding: 0;
    background-color: unset;
  }

  .reviews-navbar-right {
    display: block;
    cursor: pointer;

    @media (min-width: 768px) {
      display: none;
    }
  }

  .experience-wrapper--reviews-navbar-content {
    width: 100%;
    display: flex;
    align-items: center;
    grid-gap: 10px;
    padding: 1em 20px;
    justify-content: center;

    p {
      margin-bottom: 0;
    }

    .reviews-navbar-left {
      overflow: hidden auto;
      flex: 1;
    }

    .reviews-navbar-payments {
      text-align: center;
    }

    .reviews-navbar-right {
      text-align: right;
    }

    @media screen and (min-width: 1170px) {
      padding: 1em 0;
    }

    @media screen and (max-width: 990px) {
      grid-template-columns: 1fr auto;

      // .reviews-navbar-payments {
      //   display: none;
      // }
    }

    @media screen and (max-width: 700px) {
      grid-template-columns: 1fr;

      // .reviews-navbar-payments {
      //   display: none;
      // }

      .reviews-navbar-right {
        text-align: left;
      }
    }
  }

  p {
    line-height: 1.4;
  }
}
</style>
